<template>
  <div id="app">
    <v-container fluid class="fluidicin" grid-list-xs>
      <v-card color="grey lighten-2" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar style="height: 48px; align-items: baseline;" size="120px" dark  >
              <v-toolbar-title class="baslikfont">{{ $t('Current-Account-Trial-Balance') }}</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
          </v-flex>

          <v-flex xs12 sm12>
            <cariaracomp :etiket="'cari ara'" :@change="degis()" :ilkdeger="'B2B0000aa000005'"  v-model="denemedeneme"></cariaracomp>
          </v-flex>
          {{denemedeneme}}

 <v-flex xs12 sm12>
            <duzyaziinput :etiket="'duzyazi label'" v-model="duzyazi"></duzyaziinput>
          </v-flex>
          {{duzyazi}}

          <v-flex xs12 sm12>
            <tarih :etiket="$t('Date')" v-model="deneme1"></tarih>
          </v-flex>

               <v-flex xs12 sm12>
             <tarihcomp :etiket="$t('Sales-Date')" tabindex="13" v-bind:value="deneme1" v-model="deneme1"></tarihcomp>
          </v-flex>

          {{deneme1}}


        </v-layout>
      </v-card>

    </v-container>
  </div>
</template>


<script>
  //import auth from '../../../api/auth'
  import cariaracomp from '@/components/app/customcomp/cariaracomp.vue';
  import tarih from '@/components/app/customcomp/tarih.vue';
    import tarihcomp from '@/components/app/customcomp/tarihcomp.vue';

  import duzyaziinput from '@/components/app/customcomp/duzyaziinput.vue';

  export default {
    data() {
      return {
denemedeneme:'',
        deneme: '',
        deneme1: '',
        duzyazi:'',

        etiketana: 'selam sana',
        denemem: [1, 2],
        toplamBakiye: 0,
        toplamCariAlacak: 0,
        toplamCariBorc: 0,
        toplamGenelAlacak: 0,
        toplamGenelBorc: 0,
        toplamRisk: 0,



        loading: false,
        loading1: false,
        search3: '',
        renk: 'white',
        renk1: 'info',
        items: [],
        load: false,
        load1: true,
        butondurum: true,
        hesapkodu: [],
        anahesap: [],
        searchcariinput: '',
        hesapgurubu: [],
        e6: [],
        tumsirketler: false,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text: '',
        search: '',
        search1: '',
        cariKod: '',

        filtre: {
          a: '',
          b: '',
          c: ''
        },
        dialogfiltre: false
      }
    },
    beforeMount: beforeMount,

    watch: {
      search(val) {
        val && this.carigetir(val)
      },
      search1(val) {
        val && this.carigetir2(val)
      }
    },
    components: {
      cariaracomp,
      tarih,
      duzyaziinput,
      tarihcomp
    },
    methods: {
degis:degis,
getDateNow1:getDateNow1,
getDateNow:getDateNow
    },
  }

function degis(){
}


  function beforeMount() {
    this.deneme = 'NURULLAH58'
    this.deneme1= '0001-01-01T00:00:00'
  }


  function getDateNow() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd
    return today
  }


  function getDateNow1() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = dd + '.' + mm + '.' + yyyy
    return today
  }
</script>

<style>
</style>